import { WorkspaceStatus } from '@neptune/pricing-workspace-status-domain';

export const activeProjectsReadOnlyTrigger = (status: WorkspaceStatus): boolean =>
  status.activeProjectsLimit !== undefined &&
  status.activeProjectsUsage > status.activeProjectsLimit;
